<template>
  <template-thank-you-page></template-thank-you-page>
</template>

<script lang="ts">

import templateThankYouPage from '@/app-template/lib/pages/ThankYouPage.vue';

export default {
  name: "ThankYouPage",
  components: { templateThankYouPage },
};
</script>